export const getRankColor = (rank: string) => {
  switch (rank) {
    case 'Expert': return 'text-purple-600';
    case 'Master': return 'text-red-600';
    case 'Advanced': return 'text-blue-600';
    case 'Intermediate': return 'text-green-600';
    case 'Beginner': return 'text-yellow-600';
    default: return 'text-gray-600';
  }
};

export const getActivityIcon = (type: string) => {
  switch (type) {
    case 'snap_created':
      return 'VoteIcon';
    case 'vote_cast':
      return 'BarChartIcon';
    case 'comment_added':
      return 'MessageSquareIcon';
    case 'reaction_received':
      return 'ThumbsUpIcon';
    default:
      return 'ActivityIcon';
  }
};